module.exports = {
  RootID: 'Birch',
  Version: [0, 1, 0]
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/birch.js
 ** module id = 1
 ** module chunks = 0
 **/